// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from folder-open-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function FolderOpenFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M5.5 1a1.5 1.5 0 0 1 1.395.948L6.913 2H13.5a1.5 1.5 0 0 1 1.493 1.356L15 3.5v.633c.52.235.883.759.883 1.367l-.003.083-.006.083L15 13.5a1.5 1.5 0 0 1-1.356 1.493L13.5 15h-11c-.78 0-1.42-.595-1.49-1.31l-.007-.135-.877-7.89A1.5 1.5 0 0 1 1 4.134L1 2.5a1.5 1.5 0 0 1 1.356-1.493L2.5 1h3Zm0 1h-3a.5.5 0 0 0-.492.41L2 2.5V4h12v-.5a.5.5 0 0 0-.41-.492L13.5 3h-7a.5.5 0 0 1-.492-.41L6 2.5a.5.5 0 0 0-.41-.492L5.5 2Z"
      />
    </svg>
  );
}
